module.exports = __webpack_public_path__ + "static/media/logo_text_white.80bcd186.png";